define([
    'santa-components'
], function (
    santaComponents
) {
    'use strict';

    return santaComponents.components.SiteButton;
});
